/* eslint-disable react/no-danger */
/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import './AboutUsPage.scss';
import { useSearchParams } from 'react-router-dom';
import AppHeader from '../../shared/components/app-header/AppHeader';
import { getStringFromLS } from '../../shared/helper-utils/localStorage';
import { APP_USER_AUTH } from '../../saas/AppStorageStaticNames';
import {
  getStaticPageContent,
  sendEnquiryEmailApi,
} from '../../api/profileApi';
import { isEmpty, scrollToBottom } from '../../shared/helper-utils/appUtils';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import AppButton from '../../shared/components/app-button/AppButton';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import { useAppContext } from '../../saas/AppConfigWrapper';

function ContactUsPage() {
  const { appConfig } = useAppContext();
  const userAuth = getStringFromLS(APP_USER_AUTH);
  const [pageContent, setPageContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [validationError, setValidationError] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    number: '',
    email: '',
    querymessage: '',
  });
  const [isSearchDone, setIsSearchDone] = useState(false);
  function safeDecode(str) {
    try {
      return decodeURIComponent(str);
    } catch {
      return str;
    }
  }
  const [searchParams] = useSearchParams();
  const getPageContent = async () => {
    setIsLoading(true);
    const res = await getStaticPageContent('contact_us');
    if (
      res &&
      res.Root &&
      res.Root.Status === 'OK' &&
      !isEmpty(res.Root.Result) &&
      !isEmpty(res.Root.Result?.StaticContent?.PageContent)
    ) {
      const { PageContent } = res.Root.Result.StaticContent;
      setPageContent(safeDecode(PageContent));
    }
    setIsSearchDone(true);
    if (searchParams.get('scrollToForm')) {
      setTimeout(() => {
        scrollToBottom();
      }, 200);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    getPageContent();
  }, []);

  const handleUpdateState = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = async () => {
    let error = false;
    Object.keys(formData).forEach((x) => {
      if (isEmpty(formData[x])) {
        setValidationError(true);
        error = true;
      }
    });
    if (error) {
      return false;
    }
    setIsLoading(true);
    const response = await sendEnquiryEmailApi(formData);
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: '',
        description:
          'Our team has received your query, we will get back to you shortly',
      });
      setFormData({
        name: '',
        number: '',
        email: '',
        querymessage: '',
      });
    } else {
      setAlert({
        variant: 'error',
        title: '',
        description:
          'Our team is busy right now, please raise your enquiry later',
      });
    }
    setIsLoading(false);
  };

  return (
    <>
      {isLoading && <AppLoading isLoading={isLoading} />}
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}
      {(userAuth === null || userAuth === undefined) && <AppHeader />}
      {!isEmpty(pageContent) ? (
        <div
          className="about-us_content"
          dangerouslySetInnerHTML={{ __html: pageContent }}
        />
      ) : (
        <div className="about-us_content">Contact us</div>
      )}{' '}
      {appConfig.hasContactUsForm && isSearchDone && (
        <Row className="spacing-8 mt-2">
          <Col lg={7} md={7} sm={12} xs={12}>
            <div className="contact-us_card">
              <h4 className="primary-color">Contact Information</h4>

              <p>
                We’re here to help and answer any question you might have. We
                look forward to hearing from you.
              </p>

              <p>
                Whether you have inquiries about our services, need support, or
                want to share feedback, feel free to reach out to us.
              </p>

              <p>
                Our team will review your message and respond as soon as
                possible during business hours.
              </p>
            </div>
          </Col>

          <Col lg={5} md={5} sm={12} xs={12} className="">
            <div className="d-flex flex-column gap-2 contact-us_form">
              <AppTextInput
                placeholderText="Name *"
                errorText={validationError && 'Select Enquiry Type'}
                name=""
                value={formData.name}
                onChange={(e) => handleUpdateState('name', e.target.value)}
              />
              <AppNumberInput
                placeholderText="Contact Number *"
                errorText={validationError && 'Enter Contact Number'}
                name=""
                value={formData.number}
                onChange={(e) => handleUpdateState('number', e)}
              />
              <AppTextInput
                placeholderText="Email *"
                errorText={validationError && 'Enter Email'}
                name=""
                value={formData.email}
                onChange={(e) => handleUpdateState('email', e.target.value)}
              />
              <textarea
                placeholder="Your Message *"
                style={{
                  maxHeight: '200px',
                  padding: '8px',
                  border: '1px solid rgb(221, 221, 221)',
                  borderRadius: '6px',
                }}
                className="flex-1"
                value={formData.querymessage}
                onChange={(e) =>
                  handleUpdateState('querymessage', e.target.value)
                }
              />
              {validationError && isEmpty(formData.querymessage) && (
                <small className="app-error-text">
                  Enter your message for the enquiry
                </small>
              )}
              <div className="d-flex justify-content-center mt-2">
                <AppButton
                  variant="secondary"
                  className="px-5 white-color"
                  btnText="Submit"
                  onClick={handleSubmit}
                />
              </div>
            </div>
          </Col>
        </Row>
      )}
    </>
  );
}

export default ContactUsPage;
